export const PRODUCT_CARD_IMAGE_QUALITY = 82
export const PRODUCT_GALLERY_MAIN_IMAGE_QUALITY = 88
export const PRODUCT_GALLERY_THUMB_IMAGE_QUALITY = 80
